import classNames from 'classnames';

export interface ModalContentProps {
  className?: string;
}

export function ModalContent({ children, className }: React.PropsWithChildren<ModalContentProps>) {
  return <div className={classNames('flex-grow', className)}>{children}</div>;
}

export default ModalContent;
